<template>
  <div class="floor-warn floor">
    <div class="floor__hd">提醒您注意</div>
    <ul class="todo-list todo-list--visit clearfix" v-if="!isSF">
      <li>
        <img src="//s1.huishoubao.com/static/pc/1001/img/order-success-notice1.jpg">
        <p>拔出SIM卡，备份个人数据 </p>
        <span>（恢复出厂设置）</span>
        <el-popover
          placement="bottom"
          title="如何备份"
          width="200"
          trigger="hover"
          content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
          <div class="sync-tip">使用QQ同步助手，备份数据并删除手机数据</div>
          <a class="how-to-backup" slot="reference" href="javascript:;">如何备份？</a>
        </el-popover>
      </li>
      <li>
        <img src="//s1.huishoubao.com/static/pc/1001/img/order-success-notice4.jpg">
        <p>交易时必须携带有效身份证</p>
        <span>未成年人必须由监护人陪同，否则不能回收</span>
      </li>
      <li>
        <img src="//s1.huishoubao.com/static/pc/1001/img/order-success-notice5.jpg">
        <p style="margin-top: 15px">保持手机电量充足</p>
      </li>
    </ul>

    <ul class="todo-list todo-list--post clearfix" v-else>
      <li>
        <img src="//s1.huishoubao.com/static/pc/1001/img/order-success-notice-1.jpg" alt="">
        <div>
          <p>拔出SIM卡，备份个人数据 </p>
          <span>（最好恢复出厂设置）</span>
          <el-popover
            placement="bottom"
            title="如何备份"
            width="200"
            trigger="hover"
            content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
            <div class="sync-tip">使用QQ同步助手，备份数据并删除手机数据</div>
            <a class="how-to-backup" slot="reference" href="javascript:;">如何备份？</a>
          </el-popover>
        </div>
      </li>
      <li>
        <img src="//s1.huishoubao.com/static/pc/1001/img/order-success-notice-2.jpg" alt="">
        <div>
          <p>解锁所有账号密码</p>
          <a target="_blank" class="how-to-unlock" href="https://www.huishoubao.com/banner-deblock?pid=1004">如何解锁？ </a>
        </div>
      </li>
      <li>
        <img src="//s1.huishoubao.com/static/pc/1001/img/order-success-notice-3.jpg" alt="">
        <div>
          <p>请您为手机充电</p>
          <p class="p2">以节省检测时间，更快收到打款</p>
        </div>
      </li>
      <li>
        <img src="//s1.huishoubao.com/static/pc/1001/img/order-success-notice-4.jpg" alt="">
        <div>
          <p>将手机号姓名写在纸条上一起邮寄</p>
          <p class="p2">下单手机号和邮寄手机号需保持一致</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Popover, Button } from 'element-ui';

export default {
  props: {
    isSF: Boolean,
    isSM: Boolean
  },
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover
  }
};
</script>

<style lang="postcss" scoped>
li {
  position: relative;
  float: left;
  width: 340px;
  height: 278px;
  font-size: 16px;
  margin-left: 40px;
  text-align: center;
  p {
    padding: 10px 0 5px 0;
    color: #333333;
  }
  span {
    color: #999;
  }
  a {
    color: rgb( 55, 130, 255 );
  }
}

.sync-tip {
  line-height: 30px;
}

.todo-list--post {
  padding-bottom: 20px;
  img {
    width: 250px;
    height: 278px;
  }
  li {
    float: left;
    width: 250px;
    height: 278px;
    margin-left: 40px;
    text-align: center;
    position: relative;
    div {
      width: 100%;
      position: absolute;
      top: 205px;
      font-size: 15px;
      text-align: center;
    }
    p {
      color: #333333;
      padding: 10px 0 5px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/orderResult/floor-warn.vue